import {useEffect, useLayoutEffect, useMemo, useRef, useState} from "react";

import {RequestState} from "@pg-mono/request-state";

import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {IAmplitudePropertyListMainOffer} from "../../../tracking/amplitude/get_amplitude_property_list_item";
import {AmplitudePropertyListView, trackAmplitudePropertyViewItemList} from "../../../tracking/amplitude/track_amplitude_property_view_item_list";
import {useElementViewportShowingUpStatus} from "../../../tracking/hooks/use_element_viewport_showing_up_status";
import {AmplitudeInvestmentListingFiltersTrigger} from "../../tracking/amplitude/get_amplitude_investment_listing_filters_applied_event_properties";
import {trackAmplitudeInvestmentListingFiltersApplied} from "../../tracking/amplitude/track_amplitude_investment_listing_filters_applied";
import {PropertyListTabTypes} from "../actions/fetch_offer_detail_properties";

export interface IOfferDetailPropertyListFiltersAppliedIntent {
    id: number;
    filterValues: ISearchFiltersFormValues;
    filterTrigger: AmplitudeInvestmentListingFiltersTrigger;
    tab: PropertyListTabTypes;
}

interface IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams {
    offer: IAmplitudePropertyListMainOffer;
    offerId: number;
    properties: IPropertyListProperty[];
    itemListName: string;
    listView: AmplitudePropertyListView;
    queryKey: string;
    requestState: RequestState;
    filtersAppliedIntent: IOfferDetailPropertyListFiltersAppliedIntent;
    isFilterRequestPending: boolean;
    currentTab: PropertyListTabTypes;
}

/**
 * Amplitude tracking for the "Mieszkania w inwestycji" list on the offer (investment) page.
 *
 * `listing_filters_applied` is emitted for a successfully committed filter response first. The matching
 * `view_item_list` then reuses the very same DSA-A-37 item_list_id and remains visibility based.
 */
export const useOfferDetailPropertyListAmplitudeViewItemListTracking = (params: IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams) => {
    const {offer, offerId, properties, itemListName, listView, queryKey, requestState, filtersAppliedIntent, isFilterRequestPending, currentTab} = params;

    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking: true});

    const propertyIdsKey = properties.map((property) => property.id).join(",");
    const contextKey = `${offerId}|${queryKey}|${propertyIdsKey}`;

    const [context, setContext] = useState<{key: string; itemListId: string; seq: number} | null>(null);

    // Commit a context only for the final successful response and before the updated list can be clicked. During a
    // filter request Redux can expose the new properties before the child reports its committed filters back to the
    // parent; the explicit pending flag keeps us from minting an intermediate id for that half-updated state.
    useLayoutEffect(() => {
        if (requestState !== RequestState.Success || isFilterRequestPending) {
            return;
        }

        const itemListId = `${Math.floor(Date.now() / 1000)}_investment_apartments_${offerId}`;

        setContext((currentContext) =>
            currentContext?.key === contextKey
                ? currentContext
                : {
                      key: contextKey,
                      // the DSA-A-37 fallback shape has a one second resolution, so seq - not the id - is what keeps
                      // two lists minted within the same second apart for the dedupe below
                      seq: (currentContext?.seq ?? 0) + 1,
                      itemListId
                  }
        );
    }, [contextKey, isFilterRequestPending, offerId, requestState]);

    const isContextReady = context?.key === contextKey;
    const itemListId = isContextReady ? context.itemListId : undefined;
    const seq = isContextReady ? context.seq : undefined;

    const prevTrackedFiltersIntentIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (
            requestState !== RequestState.Success ||
            isFilterRequestPending ||
            !itemListId ||
            filtersAppliedIntent.tab !== currentTab ||
            prevTrackedFiltersIntentIdRef.current === filtersAppliedIntent.id
        ) {
            return;
        }

        trackAmplitudeInvestmentListingFiltersApplied({
            filterValues: filtersAppliedIntent.filterValues,
            filterTrigger: filtersAppliedIntent.filterTrigger,
            itemListId
        });

        prevTrackedFiltersIntentIdRef.current = filtersAppliedIntent.id;
    }, [currentTab, filtersAppliedIntent, isFilterRequestPending, itemListId, requestState]);

    const prevTrackedKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (
            isWaitingForElement ||
            requestState !== RequestState.Success ||
            isFilterRequestPending ||
            !itemListId ||
            seq === undefined ||
            properties.length === 0
        ) {
            return;
        }

        const trackedKey = `${seq}|${listView}`;

        if (prevTrackedKeyRef.current === trackedKey) {
            return;
        }

        prevTrackedKeyRef.current = trackedKey;

        trackAmplitudePropertyViewItemList({
            offer,
            properties,
            itemListId,
            itemListName,
            location: "investment_page",
            listView
        });
    }, [isWaitingForElement, requestState, isFilterRequestPending, seq, itemListId, listView, properties, offer, itemListName]);

    const itemListContext = useMemo(() => (itemListId ? {itemListId, itemListName} : null), [itemListId, itemListName]);

    return {containerId, itemListId, itemListContext};
};
import {useEffect, useLayoutEffect, useMemo, useRef, useState} from "react";

import {RequestState} from "@pg-mono/request-state";

import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {IAmplitudePropertyListMainOffer} from "../../../tracking/amplitude/get_amplitude_property_list_item";
import {AmplitudePropertyListView, trackAmplitudePropertyViewItemList} from "../../../tracking/amplitude/track_amplitude_property_view_item_list";
import {useElementViewportShowingUpStatus} from "../../../tracking/hooks/use_element_viewport_showing_up_status";
import {AmplitudeInvestmentListingFiltersTrigger} from "../../tracking/amplitude/get_amplitude_investment_listing_filters_applied_event_properties";
import {trackAmplitudeInvestmentListingFiltersApplied} from "../../tracking/amplitude/track_amplitude_investment_listing_filters_applied";
import {PropertyListTabTypes} from "../actions/fetch_offer_detail_properties";

export interface IOfferDetailPropertyListFiltersAppliedIntent {
    id: number;
    filterValues: ISearchFiltersFormValues;
    filterTrigger: AmplitudeInvestmentListingFiltersTrigger;
    tab: PropertyListTabTypes;
}

interface IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams {
    offer: IAmplitudePropertyListMainOffer;
    offerId: number;
    properties: IPropertyListProperty[];
    itemListName: string;
    listView: AmplitudePropertyListView;
    queryKey: string;
    requestState: RequestState;
    filtersAppliedIntent: IOfferDetailPropertyListFiltersAppliedIntent;
    isFilterRequestPending: boolean;
    currentTab: PropertyListTabTypes;
}

/**
 * Amplitude tracking for the "Mieszkania w inwestycji" list on the offer (investment) page.
 *
 * `listing_filters_applied` is emitted for a successfully committed filter response first. The matching
 * `view_item_list` then reuses the very same DSA-A-37 item_list_id and remains visibility based.
 */
export const useOfferDetailPropertyListAmplitudeViewItemListTracking = (params: IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams) => {
    const {offer, offerId, properties, itemListName, listView, queryKey, requestState, filtersAppliedIntent, isFilterRequestPending, currentTab} = params;

    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking: true});

    const propertyIdsKey = properties.map((property) => property.id).join(",");
    const contextKey = `${offerId}|${queryKey}|${propertyIdsKey}`;

    const [context, setContext] = useState<{key: string; itemListId: string; seq: number} | null>(null);

    // Commit a context only for the final successful response and before the updated list can be clicked. During a
    // filter request Redux can expose the new properties before the child reports its committed filters back to the
    // parent; the explicit pending flag keeps us from minting an intermediate id for that half-updated state.
    useLayoutEffect(() => {
        if (requestState !== RequestState.Success || isFilterRequestPending) {
            return;
        }

        const itemListId = `${Math.floor(Date.now() / 1000)}_investment_apartments_${offerId}`;

        setContext((currentContext) =>
            currentContext?.key === contextKey
                ? currentContext
                : {
                      key: contextKey,
                      // the DSA-A-37 fallback shape has a one second resolution, so seq - not the id - is what keeps
                      // two lists minted within the same second apart for the dedupe below
                      seq: (currentContext?.seq ?? 0) + 1,
                      itemListId
                  }
        );
    }, [contextKey, isFilterRequestPending, offerId, requestState]);

    const isContextReady = context?.key === contextKey;
    const itemListId = isContextReady ? context.itemListId : undefined;
    const seq = isContextReady ? context.seq : undefined;

    const prevTrackedFiltersIntentIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (
            requestState !== RequestState.Success ||
            isFilterRequestPending ||
            !itemListId ||
            filtersAppliedIntent.tab !== currentTab ||
            prevTrackedFiltersIntentIdRef.current === filtersAppliedIntent.id
        ) {
            return;
        }

        trackAmplitudeInvestmentListingFiltersApplied({
            filterValues: filtersAppliedIntent.filterValues,
            filterTrigger: filtersAppliedIntent.filterTrigger,
            itemListId
        });

        prevTrackedFiltersIntentIdRef.current = filtersAppliedIntent.id;
    }, [currentTab, filtersAppliedIntent, isFilterRequestPending, itemListId, requestState]);

    const prevTrackedKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (
            isWaitingForElement ||
            requestState !== RequestState.Success ||
            isFilterRequestPending ||
            !itemListId ||
            seq === undefined ||
            properties.length === 0
        ) {
            return;
        }

        const trackedKey = `${seq}|${listView}`;

        if (prevTrackedKeyRef.current === trackedKey) {
            return;
        }

        prevTrackedKeyRef.current = trackedKey;

        trackAmplitudePropertyViewItemList({
            offer,
            properties,
            itemListId,
            itemListName,
            location: "investment_page",
            listView
        });
    }, [isWaitingForElement, requestState, isFilterRequestPending, seq, itemListId, listView, properties, offer, itemListName]);

    const itemListContext = useMemo(() => (itemListId ? {itemListId, itemListName} : null), [itemListId, itemListName]);

    return {containerId, itemListId, itemListContext};
};
